export const getPolicyImagePath = (policyId) => {
  return `/img/policies/${policyId}.jpg`;
}